import React from 'react';
import PropTypes from 'prop-types';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import { Select, InputNumber, message, Button } from 'antd';
import { hashHistory } from 'react-router'

const Option = Select.Option;

export default class ArchiveProcessClassDetailPage extends React.Component {
  static propTypes = {
  };

  constructor(props) {
    super(props);
    let currentSemester = SharedTools.getCurrentSemester();
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      schoolId: this.props.params.schoolId,
      semester: props.location.query.semester ? props.location.query.semester : currentSemester,
      gradeName: props.location.query.gradeName ? props.location.query.gradeName : '',
      gradeId: props.location.query.gradeId ? props.location.query.gradeId : '',
      semesters: [],
      statistic_templates: [],
      currentSemester
    };

    this.submit = this.submit.bind(this)
  }

  componentDidMount() {

    DataService.getSchoolInfo(this.state.schoolId).then((school) => {
      let currentSemester = this.state.currentSemester
      if (school && school.archive_semester_count == 1) {
        let year = currentSemester.toString().split('').slice(0, 4).join('');
        currentSemester = Number(year + '1');
      }
      let semesters = SharedTools.getAllSemesters(currentSemester, 20201, school.archive_semester_count)

      this.setState({
        semester: this.state.semester,
        semesters,
      })
      this.getClassGradeStatistics()
    }).catch((error) => {
      console.log(error);
    });
  }

  getClassGradeStatistics() {
    let data = {
      semester: this.state.semester,
      class_grade_id: this.state.gradeId
    }
    DataService.getStatisticTemplatesIndex(data).then(res => {
      this.setState({
        statistic_templates: res
      })
    }).catch((error) => {
      message.error('获取失败');
    })
  }

  onChange(value) {
    console.log(value)
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getClassGradeStatistics();
      })
    }
  }

  _selectSemesterBox() {
    return (
      <div className="select-semester-box">
        <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester.bind(this)}>
          {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
        </Select>
      </div>
    )
  }

  onChange(id, value) {
    let { statistic_templates } = this.state;
    let template = statistic_templates.find(t => t.id == id);
    if (template) {
      template.value = value
    }

    this.setState({
      statistic_templates
    })
  }

  submit() {
    let { statistic_templates } = this.state;
    let ids = statistic_templates.map(t => t.id),
        target_values = statistic_templates.map(t => {
          return t.value ? t.value : t.target_value
        });
    let data = {
      ids,
      target_values
    }
    DataService.updateStatisticTemplates(data).then(res => {
      message.success('更新成功');
      setTimeout(function () { hashHistory.goBack(); }, 1000)
    }).catch((error) => {
      message.error('更新失败');
    })
  }

  render() {
    let { gradeName, statistic_templates } = this.state;
    return (
      <div className="archive-process-class-detail-page archive-content-setting-class-page">
        {this._selectSemesterBox()}
        <div className="page-header">
          {gradeName} <span className="header-label">档案配置修改</span>
        </div>
        <div className="process-list">
          <div className="process-item process-header">
            <div>模板</div>
            <div>当前配置数量</div>
            <div>修改配置数量</div>
            {/* <div className="page-detail">配置模板</div> */}
          </div>
          {statistic_templates.map(item => <div className="process-item process-detail" key={item.id}>
            <div>{item.title}</div>
            <div>{item.target_value}</div>
            <div>
              <InputNumber onChange={this.onChange.bind(this, item.id)} value={item.value ? item.value : item.target_value} />
            </div>
          </div>)}
        </div>
        <div className="page-footer">
          <Button type="primary" onClick={this.submit}>确认修改</Button>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/process/ArchiveProcessSettingPage.jsx